import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2850e0a5&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=2850e0a5&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2850e0a5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2850e0a5')) {
      api.createRecord('2850e0a5', component.options)
    } else {
      api.reload('2850e0a5', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2850e0a5&scoped=true", function () {
      api.rerender('2850e0a5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/page/lock/index.vue"
export default component.exports